/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Alert_Kestrel_FlopInputs */

const en_warm_alert_kestrel_flop = /** @type {(inputs: Warm_Alert_Kestrel_FlopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Average`)
};

const de_warm_alert_kestrel_flop = /** @type {(inputs: Warm_Alert_Kestrel_FlopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchschnitt`)
};

/**
* | output |
* | --- |
* | "Average" |
*
* @param {Warm_Alert_Kestrel_FlopInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_alert_kestrel_flop = /** @type {((inputs?: Warm_Alert_Kestrel_FlopInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Alert_Kestrel_FlopInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_alert_kestrel_flop(inputs)
	return de_warm_alert_kestrel_flop(inputs)
});